import {
	onKeyUpEscape,
	qsRequired,
} from '@/scripts/core/global'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class ExpandableContent extends UcoastEl{
	static htmlSelector = 'expandable-content'
	mainDetailsToggle: HTMLDetailsElement
	summary: HTMLElement
	content: HTMLElement

	constructor() {
		super()
		this.mainDetailsToggle = qsRequired('details', this)
		this.summary = qsRequired('summary', this.mainDetailsToggle)
		this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this))
		this.summary.addEventListener('click', this.onClick.bind(this))
		this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this))
		this.content = qsRequired('[data-expandable-area]', this)
		this.mainDetailsToggle.addEventListener('keyup', onKeyUpEscape)
	}

	close() {
		this.mainDetailsToggle.removeAttribute('open')
		qsRequired('summary', this.mainDetailsToggle).setAttribute('aria-expanded', 'false')
	}

	onFocusOut() {
		setTimeout(() => {
			if (!this.contains(document.activeElement)) this.animateClose()
		})
	}
	onToggle(e: Event) {
		e.preventDefault()
	}
	onClick(e: Event) {
		e.preventDefault()
		this.content.getAnimations().forEach(animation => animation.cancel());
		if (this.summary.getAttribute('aria-expanded') !== 'true') {
			this.animateOpen()
		} else {
			this.animateClose()
		}
	}
	animateOpen() {
		this.mainDetailsToggle.setAttribute('open', '');
		this.summary.setAttribute('aria-expanded', 'true');
		this.content.style.maxHeight = `${this.content.scrollHeight}px`;
	}
	animateClose() {
		this.content.style.maxHeight = `0`;
		this.summary.setAttribute('aria-expanded', 'false');
		window.setTimeout(() => {
			this.mainDetailsToggle.removeAttribute('open');
		}, 301)
	}
}
